import { PartTypeType } from "../types";
import { isTube } from "./isBarOrProfile";
import { isSheetPartType } from "./isSheetPartType";

export const isPartTypeCompatibleWithFeaturesDetection = (
  partType: PartTypeType | undefined | null,
): boolean => {
  return isSheetPartType(partType) || isTube(partType);
};
